module.exports = {
  "zones": {
    "Europe/Nicosia": ["z", {
      "wallclock": 904608000000,
      "format": "EE%sT",
      "abbrev": "EEST",
      "offset": 7200000,
      "posix": 904597200000,
      "save": 3600000,
      "rules": "EUAsia"
    }, {
      "wallclock": -1518912000000,
      "format": "EE%sT",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": -1518920008000,
      "save": 0,
      "rules": "Cyprus"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 8008000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "EUAsia": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1979,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 0
    }],
    "Cyprus": [{
      "from": 1981,
      "to": 1998,
      "month": 2,
      "day": [0, -31],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1979,
      "to": 1997,
      "month": 8,
      "day": [0, -30],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [7, 25],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1976,
      "to": 1976,
      "month": 4,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1976,
      "to": 1976,
      "month": 9,
      "day": [7, 11],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1975,
      "to": 1975,
      "month": 3,
      "day": [7, 13],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1975,
      "to": 1975,
      "month": 9,
      "day": [7, 12],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};